export default __webpack_public_path__ + "static/media/mypic1.c3d60b63.jpg";